import { __exports as r } from "./index84.js";
import { __require as y } from "./index85.js";
import { __require as P } from "./index86.js";
import { __require as s } from "./index87.js";
import { __require as p } from "./index88.js";
import { __require as v } from "./index89.js";
import { __require as O } from "./index90.js";
import { __require as j } from "./index91.js";
import { __require as k } from "./index92.js";
var b;
function M() {
  return b ? r : (b = 1, function(e) {
    var t = r && r.__assign || function() {
      return t = Object.assign || function(g) {
        for (var a, n = 1, q = arguments.length; n < q; n++) {
          a = arguments[n];
          for (var i in a) Object.prototype.hasOwnProperty.call(a, i) && (g[i] = a[i]);
        }
        return g;
      }, t.apply(this, arguments);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Delete = e.Screen = e.Page = e.Track = e.Identify = e.Group = e.Alias = e.Facade = void 0;
    var u = y();
    Object.defineProperty(e, "Facade", { enumerable: !0, get: function() {
      return u.Facade;
    } });
    var c = P();
    Object.defineProperty(e, "Alias", { enumerable: !0, get: function() {
      return c.Alias;
    } });
    var f = s();
    Object.defineProperty(e, "Group", { enumerable: !0, get: function() {
      return f.Group;
    } });
    var o = p();
    Object.defineProperty(e, "Identify", { enumerable: !0, get: function() {
      return o.Identify;
    } });
    var _ = v();
    Object.defineProperty(e, "Track", { enumerable: !0, get: function() {
      return _.Track;
    } });
    var d = O();
    Object.defineProperty(e, "Page", { enumerable: !0, get: function() {
      return d.Page;
    } });
    var l = j();
    Object.defineProperty(e, "Screen", { enumerable: !0, get: function() {
      return l.Screen;
    } });
    var m = k();
    Object.defineProperty(e, "Delete", { enumerable: !0, get: function() {
      return m.Delete;
    } }), e.default = t(t({}, u.Facade), {
      Alias: c.Alias,
      Group: f.Group,
      Identify: o.Identify,
      Track: _.Track,
      Page: d.Page,
      Screen: l.Screen,
      Delete: m.Delete
    });
  }(r), r);
}
export {
  M as __require
};
//# sourceMappingURL=index83.js.map
